import React from 'react';
import { Modal, Box } from '@mui/material';

const NodeConfigModal = ({ open, onClose, children }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: '#2C2B2D',
                    boxShadow: 24,
                    width: 'min(959px, 92vw)',
                    height: 'min(515px, 88vh)',
                    borderRadius: '3px',
                    border: '1px solid rgba(173, 180, 189, 0.45)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                <Box sx={{ height: '100%' }}>
                    {children}
                </Box>
            </Box>

        </Modal>
    );
};

export default NodeConfigModal;
